import { backofficeRequest } from '../../axios'

async function subscribeUserToPushNotification(userId, subscription) {
  try {
    const res = await backofficeRequest.post(
      `/backoffice/notifications/subscribe`,
      {
        userId,
        subscription,
      }
    )
    return res
  } catch (error) {
    return error.response
  }
}
export { subscribeUserToPushNotification }
